export enum ESTABLISHMENT_TYPE {
  NEW_UNIT = 'NEW',
  IMPROVE = 'SISAN',
  FORMAT_CHANGE = 'FORMAT_TRANSFORMATION',
  RELOCATION = 'RELOCATION',
  CLOSE = 'CLOSE',
}
export interface createProjectType {
  id: ESTABLISHMENT_TYPE;
  caption: string;
  title: string;
}
export const projectTypes: createProjectType[] = [
  {
    id: ESTABLISHMENT_TYPE.NEW_UNIT,
    caption: 'projectTypesCaption.newUnit',
    title: 'projectTypes.newUnit',
  },
  {
    id: ESTABLISHMENT_TYPE.IMPROVE,
    caption: 'projectTypesCaption.improve',
    title: 'projectTypes.improve',
  },
  {
    id: ESTABLISHMENT_TYPE.FORMAT_CHANGE,
    caption: 'projectTypesCaption.formatChange',
    title: 'projectTypes.formatChange',
  },

  {
    id: ESTABLISHMENT_TYPE.RELOCATION,
    caption: 'projectTypesCaption.relocation',
    title: 'projectTypes.relocation',
  },
  {
    id: ESTABLISHMENT_TYPE.CLOSE,
    caption: 'projectTypesCaption.close',
    title: 'projectTypes.close',
  },
];

export const onProjectTypeClick = (
  projectId: ESTABLISHMENT_TYPE,
  handleOpenCreateNewUnitModal: () => void,
  handleOpenCreateImproveModal: () => void,
  handleOpenFormatChangeModal: () => void,
  handleOpenRelocationModal: () => void,
  handleOpenCloseProjectModal: () => void,
  startAction: () => void,
) => {
  switch (projectId) {
    case ESTABLISHMENT_TYPE.NEW_UNIT: {
      handleOpenCreateNewUnitModal();
      startAction();
      return;
    }
    case ESTABLISHMENT_TYPE.IMPROVE: {
      handleOpenCreateImproveModal();
      startAction();
      return;
    }
    case ESTABLISHMENT_TYPE.FORMAT_CHANGE: {
      handleOpenFormatChangeModal();
      startAction();
      return;
    }
    case ESTABLISHMENT_TYPE.RELOCATION: {
      handleOpenRelocationModal();
      startAction();
      return;
    }
    case ESTABLISHMENT_TYPE.CLOSE: {
      handleOpenCloseProjectModal();
      startAction();
      return;
    }
    default:
      alert('Project Type is not implemented');
  }
};
